import cn from 'classnames';

import { setJumpLinkAttributes } from 'src/utils/jumpLinks';

import ArticleGrid from 'components/BaseHelpers/ArticleGrid/ArticleGrid';
import Cta from 'components/BaseHelpers/Cta';
import RichText from 'components/BaseHelpers/RichText';
import StartIndex from 'components/BaseHelpers/StartIndex';
import StopIndex from 'components/BaseHelpers/StopIndex';
import Text from 'components/BaseHelpers/Text';

import { ComponentProps } from '../../../types/component-props';
import { CoreRecentFeaturedNewsInsightsData } from '../../../types/components';

import styles from './CoreRecentFeaturedNewsInsights.module.scss';

export type CoreRecentFeaturedNewsInsightsProps = ComponentProps &
  CoreRecentFeaturedNewsInsightsData;

const CoreRecentFeaturedNewsInsights = (
  props: CoreRecentFeaturedNewsInsightsProps
): JSX.Element => {
  const { heading, description, items, cta, jumpLinkLabel } = props.fields;

  if (items.length === 0) {
    return <></>;
  }

  return (
    <>
      <StopIndex />
      <div className={cn(styles.main, 'container-10')} {...setJumpLinkAttributes(jumpLinkLabel)}>
        <Text tag="h2" className={cn('heading-h3', styles.heading)} field={heading} />
        <RichText className="body-med" field={description} />
        <ArticleGrid items={items} className={styles.grid} />
        <Cta tag="a" className={styles.cta} href={cta.href} openNewTab={cta.target === '_blank'}>
          {cta.label}
        </Cta>
      </div>
      <StartIndex />
    </>
  );
};

export default CoreRecentFeaturedNewsInsights;
